// extracted by mini-css-extract-plugin
module.exports = {"root__div":"OfferItem_root__div__3EVJ_","clickable":"OfferItem_clickable__3UIV4"};